<template>
  <div>
    <b-button
      v-b-toggle.sidebar-right-questions
      v-b-tooltip.hover
      pill
      title="Perguntas frequentes"
      class="float-questions"
      variant="info"
      @click="listar()"
    >
      <b-icon scale="2" icon="question" class="icone"></b-icon>
    </b-button>
    <b-sidebar
      :width="isMobile ? '100%' : '25%'"
      id="sidebar-right-questions"
      :sidebar-class="
        isMobile
          ? 'sidebar-right-questions-mobile'
          : 'sidebar-right-questions-desktop'
      "
      right
      shadow
    >
      <template #header="{ hide }">
        <div class="header-questions">
          <b-row class="text-center m-0 p-0 mt-2">
            <font-awesome-icon
              :icon="['fa', 'xmark']"
              title="Fechar"
              style="cursor: pointer"
              size="sm"
              @click="hide"
            />
            <b-col cols="11">
              <h5>Perguntas frequentes</h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-input
                size="sm"
                id="filtro"
                class="text-center center"
                placeholder="Pesquisar por termo"
                v-model="termoPesquisa"
                autocomplete="off"
                @change="changeTermoPesquisa()"
              >
              </b-form-input>

              <div class="text-center mt-2">
                <b-button
                  class="mb-1"
                  size="sm"
                  variant="primary"
                  pill
                  @click="pesquisar()"
                >
                  <font-awesome-icon :icon="['fa', 'search']" /> Pesquisar
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
      <template #default>
        <div class="teste px-3 py-2">
          <b-row
            v-for="(pergunta, index) in listaPerguntasFiltrada"
            :key="index"
          >
            <b-col>
              <hr />
              <b-link class="link-questions" @click="perguntaClick(pergunta)">
                <div>
                  <font-awesome-icon
                    :icon="getArrowIcon(pergunta)"
                    class="mr-2"
                  />{{ pergunta.ordem }} - {{ pergunta.pergunta }}
                </div>
              </b-link>
              <b-collapse v-model="pergunta.showResposta" class="mt-3">
                <div class="text-justify ml-4">
                  <span class="text-secondary">{{ pergunta.resposta }}</span>
                </div>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
export default {
  name: "PerguntasFrequentes",
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
  },
  data() {
    return {
      listaPerguntas: [],
      listaPerguntasFiltrada: [],
      termoPesquisa: "",
    };
  },
  methods: {
    listar() {
      this.$api.Multa.listarPerguntaFrequente({})
        .then((response) => {
          if (response.data.success && response.data.data) {
            this.listaPerguntas = [];
            response.data.data.forEach((item) => {
              this.termoPesquisa = "";
              this.$set(item, "showResposta", false);
              this.listaPerguntas.push(item);
              this.setListaPerguntasFiltrada();
            });
          }
        })
        .catch(() => {});
    },

    adicionaAtributoShowResposta() {
      this.listaPerguntas.forEach((item) => {
        this.$set(item, "showResposta", false);
      });
    },

    setListaPerguntasFiltrada() {
      this.listaPerguntasFiltrada = [];
      this.listaPerguntas.forEach((item) => {
        this.listaPerguntasFiltrada.push(item);
      });
    },

    perguntaClick(pergunta) {
      pergunta.showResposta = !pergunta.showResposta;
    },

    getArrowIcon(pergunta) {
      return pergunta.showResposta
        ? ["fa", "chevron-down"]
        : ["fa", "chevron-right"];
    },

    pesquisar() {
      this.listaPerguntasFiltrada = this.listaPerguntas.filter((pergunta) => {
        return (
          pergunta.resposta.toLowerCase().includes(this.termoPesquisa.toLowerCase()) ||
          pergunta.pergunta.toLowerCase().includes(this.termoPesquisa.toLowerCase())
        );
      });
    },

    changeTermoPesquisa() {
      if (this.termoPesquisa == "") {
        this.setListaPerguntasFiltrada();
      } else {
        this.pesquisar();
      }
    },
  },
  mounted() {},
};
</script>

<style>
.float-questions {
  position: fixed;
  width: 55px;
  height: 55px;
  bottom: 80px;
  right: 20px;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.link-questions {
  color: initial;
  text-decoration: none;
}

.sidebar-right-questions-desktop {
  height: 100%;
}

.sidebar-right-questions-mobile {
  height: 100%;
}

.header-questions {
  width: 100%;
}
</style>